import { render, staticRenderFns } from "./CustomerData.vue?vue&type=template&id=43c5abe2&"
import script from "./CustomerData.vue?vue&type=script&lang=ts&"
export * from "./CustomerData.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerData.vue?vue&type=style&index=0&id=43c5abe2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports